import { api } from '../../lib/apiClient';

/**
 * Notifications are per-user and cross-workspace, so (unlike files/comments)
 * these endpoints are not workspace-scoped.
 */
export const notificationKeys = {
  list: (unread) => ['notifications', { unread: Boolean(unread) }],
  unreadCount: () => ['notifications', 'unread-count'],
  preferences: () => ['notification-preferences'],
};

export async function listNotifications({ unread } = {}) {
  const { data } = await api.get('/me/notifications', {
    params: { limit: 50, ...(unread ? { unread: 'true' } : {}) },
  });
  return data;
}

export async function unreadCount() {
  const { data } = await api.get('/me/notifications/unread-count');
  return data.count;
}

export const markRead = (id) => api.post(`/me/notifications/${id}/read`);
export const markAllRead = () => api.post('/me/notifications/read-all');
export const markAllSeen = () => api.post('/me/notifications/seen');

export async function getPreferences() {
  const { data } = await api.get('/me/notification-preferences');
  return data;
}

export async function setPreference({ type, channel, enabled }) {
  const { data } = await api.put('/me/notification-preferences', { type, channel, enabled });
  return data;
}
